<p>front-channel-logout works!</p>
